(function($) {
  Drupal.behaviors.trendReportContentToutV1 = {
    attach: function(context) {
      var $module = $('.js-trend-report-content-v1', context);
      var $launcher = $module.find('.js-video-launcher');
      var $play = $module.find('.js-play-button-icon');

      if ($play.length) {
        $play.addClass('js-video-launch-trigger').off('click.play').on('click.play', function(event) {
          event.preventDefault();
          $launcher.trigger('click');
        });
      }
    },
  };
})(jQuery);
